import {GetSeferData} from "SeferPetach/GetData";

export async function getUserTag() {
    var args = {};
    var payload = await GetSeferData("usf1", args);
    return (payload);
}